// src/utils/planShape.js
// What the next round will look like, for showing before it is created. This mirrors plan_shape() in
// backend/entities.py: the backend decides, this is only a preview (both are tested with the same cases).

export const PLAYERS_PER_MATCHUP = 4; // two teams of two

// { doubles, singles, sitting } for a round of `players` active players.
// Doubles first, as many as the players (and the courts) allow. With singles on, two of the players left
// over play a singles game instead of sitting out, if a court is free for it.
export function planShape(players, courts, singlesEnabled) {
    let doubles = Math.floor(players / PLAYERS_PER_MATCHUP);
    if (courts) doubles = Math.min(doubles, courts);
    let singles = 0;
    if (singlesEnabled) {
        const leftOver = players - PLAYERS_PER_MATCHUP * doubles;
        const freeCourts = courts ? courts - doubles : leftOver;
        singles = Math.max(0, Math.min(Math.floor(leftOver / 2), freeCourts, 1));
    }
    return { doubles, singles, sitting: players - PLAYERS_PER_MATCHUP * doubles - 2 * singles };
}

const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;

// "1 doubles matchup, 1 singles game, 1 sitting out" (null when a round is not possible yet).
export function describeNextRound(players, courts, singlesEnabled) {
    if (players < PLAYERS_PER_MATCHUP) return null;
    const { doubles, singles, sitting } = planShape(players, courts, singlesEnabled);
    const parts = [plural(doubles, 'doubles matchup')];
    if (singles) parts.push(plural(singles, 'singles game'));
    if (sitting) parts.push(`${sitting} sitting out`);
    return parts.join(', ');
}
